export default "__VITE_ASSET__C5pv$H9B__"